import { render } from "./manufacture.vue?vue&type=template&id=4d0ed08f&scoped=true"
import script from "./manufacture.vue?vue&type=script&lang=js"
export * from "./manufacture.vue?vue&type=script&lang=js"

import "./manufacture.vue?vue&type=style&index=0&id=4d0ed08f&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0ed08f"]])

export default __exports__